/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const contactActivityQueryParamsSchema = z.object({
    "sortOrder": z.optional(z.enum(["asc", "desc"]).describe("asc or desc; default depends on sortBy (recent: desc, score: desc, name: asc)")),
"sortBy": z.optional(z.enum(["recent", "score", "name"]).describe("'recent' (default) — most recent event first; 'score' — research priority score; 'name' — alphabetical (case-insensitive). Contacts lacking a value for the chosen field (no dated events / no research execution / no name) always sort last, regardless of sortOrder.")),
"includeLastExecution": z.optional(z.any().describe("Whether to attach each contact's last research execution (default true)")),
"eventsPerContact": z.optional(z.any().describe("Max events per contact (default 50, max 200)")),
"cursor": z.optional(z.any().describe("Opaque cursor from a previous response's nextCursor — omit for the first page. Must be reused with the same sortBy/sortOrder it was issued for, or the request is rejected.")),
"limit": z.optional(z.any().describe("Page size (default 25, max 100)"))
    }).optional()

export const contactActivityHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contacts page, ordered per sortBy/sortOrder (default: most recent event first)
 */
export const contactActivity200Schema = z.object({
    "items": z.array(z.object({
    "contact": z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    }),
"events": z.array(z.object({
    "id": z.string(),
"contactId": z.string(),
"userId": z.string(),
"source": z.string(),
"type": z.enum(["travel", "family", "purchase", "relocation", "social", "social-media-interaction", "professional", "milestone", "direct-contact-inbound", "direct-contact-outbound"]),
"description": z.string(),
"eventDate": z.nullable(z.string()),
"externalId": z.string(),
"unreliableExternalId": z.boolean(),
"firstSeenAt": z.iso.datetime(),
"lastSeenAt": z.iso.datetime(),
"createdAt": z.iso.datetime()
    })),
"lastExecution": z.object({
    "contactId": z.string(),
"userId": z.string(),
"status": z.enum(["success", "failed", "timeout"]),
"errorMessage": z.nullable(z.string()),
"priorityScore": z.nullable(z.number()),
"summary": z.nullable(z.string()),
"suggestedApproach": z.nullable(z.string()),
"insights": z.nullable(z.array(z.string())),
"lastEventRelevancyScore": z.nullable(z.number()),
"lastEventFollowUp": z.nullable(z.string()),
"executedAt": z.iso.datetime()
    }).nullish()
    })),
"nextCursor": z.nullable(z.string())
    })

/**
 * @description Invalid query params, invalid cursor, or cursor issued for a different sort
 */
export const contactActivity400Schema = z.any()

export const contactActivityQueryResponseSchema = z.lazy(() => contactActivity200Schema)